import { useDispatch, useSelector } from 'react-redux';
import {
  onSegmentDeleted,
  onSegmentFilterAdded,
  onSegmentFilterBeingEditedChanged,
  onSegmentFilterChanged,
  selectFilterBeingEdited,
  selectSegmentFilters,
  selectSegmentsOrdered
} from '../segment-controls.slice';
import {
  Segment,
  SegmentChangedPayload,
  SegmentFilter,
  SegmentFilterBeingEdited,
  SegmentFilterBeingEditedChangedPayload,
  SegmentFilterChangedPayload
} from '../segment-controls.types';
import SegmentControl from './segment-control';
import { RootState } from 'app/store';

function getFilterBeingEditedBySegmentId(
  segmentId: string,
  filterBeingEdited?: SegmentFilterBeingEdited
): SegmentFilterBeingEdited | undefined {
  if (filterBeingEdited?.segmentId === segmentId) {
    return filterBeingEdited;
  }

  return undefined;
}

interface SegmentControlsProps {
  componentId: string;
  limit?: number;
}

const SegmentControls = (props: SegmentControlsProps) => {
  const { componentId, limit } = props;
  const dispatch = useDispatch();
  const segments = useSelector((state: RootState) =>
    selectSegmentsOrdered(state, componentId)
  );
  const segmentFilters = useSelector((state: RootState) =>
    selectSegmentFilters(state, componentId)
  );
  const filterBeingEdited = useSelector((state: RootState) =>
    selectFilterBeingEdited(state, componentId)
  );

  const dispatchOnFilterAdded = (segment: Segment) => {
    const payload: SegmentFilterChangedPayload = {
      componentId,
      segment
    };

    dispatch(onSegmentFilterAdded(payload));
  };

  const dispatchOnSegmentFilterBeingEditedChanged = (
    segmentFilter?: SegmentFilter
  ) => {
    const payload: SegmentFilterBeingEditedChangedPayload = {
      componentId,
      segmentFilter
    };

    dispatch(onSegmentFilterBeingEditedChanged(payload));
  };

  const dispatchOnSegmentDeleted = (segmentToDelete: Segment) => {
    const payload: SegmentChangedPayload = {
      componentId,
      segment: segmentToDelete
    };
    dispatch(onSegmentDeleted(payload));
  };

  const dispatchOnSaveSegmentFilter = () => {
    const payload: SegmentFilterChangedPayload = {
      componentId
    };
    dispatch(onSegmentFilterChanged(payload));
  };

  return (
    <div>
      {segments.map((segment, segmentIndex) => (
        <div
          key={`segment-${segmentIndex}`}
          className={`lg:mr-6 ${
            segmentIndex !== segments.length ? 'mb-2' : 'mb-4'
          }`}
        >
          <SegmentControl
            componentId={componentId}
            segment={segment}
            isFirstSegment={segmentIndex === 0}
            filters={segmentFilters ?? []}
            filterBeingEdited={getFilterBeingEditedBySegmentId(
              segment.id,
              filterBeingEdited
            )}
            isLastSegment={segmentIndex === segments.length - 1}
            hideAddBtn={limit != null && limit <= segments.length}
            onDeleteSegment={dispatchOnSegmentDeleted}
            onFilterAdded={dispatchOnFilterAdded}
            onFilterBeingEditedChanged={
              dispatchOnSegmentFilterBeingEditedChanged
            }
            onFilterSaved={dispatchOnSaveSegmentFilter}
          />
        </div>
      ))}
    </div>
  );
};

export default SegmentControls;
